import React from 'react';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';
import Icon from '../../components/Icon';
import { dateLocale, eventTime } from '../calendarUtils';

// Список событий периода: цветная точка, название, дата, время и место.
const ListView = ({ events, locale, colorOf, onOpenEvent }) => {
  const { t } = useTranslation();

  const sorted = [...events].sort((a, b) => new Date(a.start) - new Date(b.start));

  if (sorted.length === 0) {
    return (
      <div className="cal-list cal-list--empty">
        <Icon name="calendar" size={32} />
        <p>{t('calendar.agendaEmpty')}</p>
      </div>
    );
  }

  return (
    <div className="cal-list">
      {sorted.map((event) => (
        <button
          key={event.id}
          type="button"
          className="cal-list-item"
          onClick={() => onOpenEvent(event)}
        >
          <span className="cal-dot cal-list-dot" style={{ background: colorOf(event) }} />

          <span className="cal-list-main">
            <span className="cal-list-title">{event.title}</span>
            <span className="cal-list-meta">
              <span>
                <Icon name="calendar" size={13} />
                {format(new Date(event.start), 'd MMMM yyyy', { locale: dateLocale(locale) })}
              </span>
              <span>
                <Icon name="clock" size={13} />
                {eventTime(event, locale)}
              </span>
              {event.location && (
                <span>
                  <Icon name="map-pin" size={13} />
                  {event.location}
                </span>
              )}
            </span>
          </span>

          {event.attendees?.length > 0 && (
            <span className="cal-list-attendees">
              {event.attendees.slice(0, 3).map((name) => (
                <span className="cal-list-attendee" key={name} title={name}>
                  {name.trim().charAt(0).toUpperCase()}
                </span>
              ))}
            </span>
          )}

          <span className="cal-list-more">
            <Icon name="more-horizontal" size={16} />
          </span>
        </button>
      ))}
    </div>
  );
};

export default ListView;
